(function () {
  "use strict";

  function isHeading(el) {
    if (el.tagName !== "P") return false;
    var text = el.textContent.trim();
    if (!text || text.length > 65) return false;
    if (!el.querySelector("strong")) return false;
    if (/\.\s+\S/.test(text)) return false;
    var clone = el.cloneNode(true);
    clone.querySelectorAll("strong, em").forEach(function(n) { n.remove(); });
    return clone.textContent.trim() === "";
  }

  function initAccordion() {
    var desc = document.querySelector(".product__description");
    if (!desc) return;

    var children = Array.from(desc.children);

    var firstIdx = -1;
    for (var i = 0; i < children.length; i++) {
      if (isHeading(children[i])) { firstIdx = i; break; }
    }
    if (firstIdx === -1) return;

    var sections = [];
    var cur = null;
    for (var j = firstIdx; j < children.length; j++) {
      if (isHeading(children[j])) {
        cur = { heading: children[j], content: [] };
        sections.push(cur);
      } else if (cur) {
        cur.content.push(children[j]);
      }
    }

    var valid = sections.filter(function(s) { return s.content.length > 0; });
    if (valid.length === 0) return;

    var wrapper = document.createElement("div");
    wrapper.className = "dheo-acc";

    valid.forEach(function(section) {
      var item = document.createElement("div");
      item.className = "dheo-acc__item";

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "dheo-acc__btn";
      btn.setAttribute("aria-expanded", "false");

      var label = document.createElement("span");
      label.innerHTML = section.heading.innerHTML;

      var icon = document.createElement("span");
      icon.className = "dheo-acc__icon";
      icon.setAttribute("aria-hidden", "true");

      btn.appendChild(label);
      btn.appendChild(icon);

      var panel = document.createElement("div");
      panel.className = "dheo-acc__panel";
      panel.hidden = true;

      section.content.forEach(function(el) {
        panel.appendChild(el.cloneNode(true));
      });

      btn.addEventListener("click", function() {
        var open = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!open));
        panel.hidden = open;
      });

      item.appendChild(btn);
      item.appendChild(panel);
      wrapper.appendChild(item);
    });

    for (var k = children.length - 1; k >= firstIdx; k--) {
      children[k].remove();
    }

    desc.appendChild(wrapper);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAccordion);
  } else {
    initAccordion();
  }
})();
